import { render, staticRenderFns } from "./bar-relative.vue?vue&type=template&id=e984d2d0"
import script from "./bar-relative.vue?vue&type=script&lang=js"
export * from "./bar-relative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports